import * as React from 'react';
import { FC, useContext } from 'react';
import { style, keyframes } from 'typestyle';
import Next from '../../../Icons/Next';
import { StoreContext } from '../../../../services/store';

const NextIndicator: FC = () => {
  const color = 'rgba(255, 255, 255, 0.5)';
  const context = useContext(StoreContext);
  const nextContentText = context.config.nextContentText ?? 'Explore';

  return (
    <div className={styles.nextContainer}>
      <div className={styles.nextIndicator(color)}>
        <div className={styles.nextText}>{nextContentText} </div>
        <Next size={28} color={color}/>
      </div>
    </div>
  );
};

export default NextIndicator;

const float = keyframes({
  '0%': { transform: 'translateX(0px)' },
  '50%': { transform: 'translateX(8px)' },
  '100%': { transform: 'translateX(0px)' }
});

const styles = {
    nextContainer: style({
        position: 'absolute',
        top: '50%',
        right: 24,
        transform: 'translateY(-50%)',
        display: 'flex',
        justifyContent: 'center',
        width: 'auto',
        zIndex: 10,
    }),
    
    nextIndicator: (color:string) => style({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: color,
        animation: `${float} 2.5s ease-in-out infinite`,
    }),
      
    nextText: style({
        margin: '5px 0',
        fontSize: '22px',
        fontFamily: "'Dangrek', sans-serif",
    }),
}